(function(){
  function formatText(str){
    if(!str) return str;
    // Normalize whitespace
    const s = String(str).trim();
    // Match: anything + (anything)
    const m = s.match(/^(.+?)\s*\((.+)\)\s*$/);
    if(!m) return s;
    const first = m[1].trim();
    const inside = m[2].trim();
    return first + '<br>(' + inside + ')';
  }

  function applyFormatToElement(el){
    if(!el) return;
    // Avoid double-formatting
    if(el.dataset && el.dataset.formatted === 'true') return;

    let original = el.getAttribute('data-original-value');
    if(!original || !original.trim()){
      // Fallback to current text if no original saved
      original = el.textContent || '';
      // Preserve for future reformatting
      el.setAttribute('data-original-value', original);
    }

    // Only format if there are parentheses in the original
    if(original && original.indexOf('(') !== -1 && original.indexOf(')') !== -1){
      el.innerHTML = formatText(original);
      if(el.dataset) el.dataset.formatted = 'true';
    } else {
      // Ensure plain text
      el.textContent = original;
      if(el.dataset) el.dataset.formatted = 'true';
    }
  }

  function formatAll(){
    // Limit to product options area only
    document.querySelectorAll('.wt-product__options .f-swatch__label').forEach(applyFormatToElement);

    // Current selection label inside product options title
    document.querySelectorAll('.wt-product__options .wt-product__option__title .value').forEach(applyFormatToElement);
  }

  function onReady(){
    formatAll();

    // Observe dynamic changes (variant changes or re-rendering)
    const observer = new MutationObserver(function(mutations){
      let shouldFormat = false;
      for(const m of mutations){
        if(m.type === 'childList' || m.type === 'characterData' || m.type === 'attributes'){
          // If any relevant nodes are added or text changes, re-run
          if(m.addedNodes && m.addedNodes.length){
            shouldFormat = true; break;
          }
          if(m.target && (m.target.matches?.('.wt-product__options .f-swatch__label, .wt-product__options .wt-product__option__title .value') ||
                          m.target.closest?.('.wt-product__options .f-swatch__label, .wt-product__options .wt-product__option__title .value'))){
            shouldFormat = true; break;
          }
        }
      }
      if(shouldFormat){
        // Debounce a bit
        clearTimeout(onReady._t);
        onReady._t = setTimeout(formatAll, 50);
      }
    });

    observer.observe(document.body, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();
